<template>
  <div class="cmp-accounting-reports-invoice-reports invoice-reports">
    <v-layout row wrap>
      <v-flex md4 xs12>
        <TextField
          type="date"
          id="start_date"
          :placeholder="$t('start_date')"
          :value="start_date"
          :showImmediate="true"
          autocomplete="off"
          @valuechanged="onDateChange"
        />
        <TextField
          type="date"
          id="end_date"
          :placeholder="$t('end_date')"
          :value="end_date"
          :showImmediate="true"
          autocomplete="off"
          @valuechanged="onDateChange"
        />
        <Dropdown
          class="dt-dropdown"
          :options="bookingDates"
          :selected="selectedBookingDate"
          box
          :placeholder="$t('Booking Date')"
          v-on:selectedChange="(e) => onBookingDateChange(e)"
          :listHeight="150"
        ></Dropdown>
      </v-flex>
      <v-flex md4 px-3 xs12>
        <div class="invoice-project-list dt-list">
          <div class="invoice-project-item dt-list-item">
            <div class="dt-checkbox v2 dt-list-item--column">
              <input
                type="checkbox"
                :name="'invoice_project'"
                :id="'invoice_project'"
                :checked="selectAllNone"
                @click="(e) => onInvoiceProjectSelectAllNone(e)"
              />
              <div class="checkmark"></div>
            </div>
            <div class="checkbox-label dt-list-item--column">
              {{$t('select_all_none')}}
            </div>
          </div>
          <div
            v-for="invoice_project of reportData.invoice_projects"
            :key="invoice_project.invoice_project_id"
            class="invoice-project-item dt-list-item"
          >
            <div class="dt-checkbox v2 dt-list-item--column">
              <input
                type="checkbox"
                :name="'invoice_project'"
                :id="'invoice_project'"
                :checked="
                  selectedInvoiceProjects.has(
                    invoice_project.invoice_project_id
                  )
                "
                @click="
                  (e) =>
                    onInvoiceProjectSelect(
                      e,
                      invoice_project.invoice_project_id
                    )
                "
              />
              <div class="checkmark"></div>
            </div>
            <div class="checkbox-label dt-list-item--column">
              {{ invoice_project.invoice_project_name }}
            </div>
          </div>
        </div>
      </v-flex>
      <v-flex md4 px-3 xs12>
        <div class="report-buttons">
          <button
            class="dt-button v1"
            @click.stop="onInvoiceExportBookingClick"
          >
            {{ $t("invoice_export_booking") }}
          </button>
          <button class="dt-button v1" @click.stop="onInvoicelineExport">
            {{ $t("invoiceline_export") }}
          </button>
          <button class="dt-button v1" @click.stop="onCustomReportClick">
            {{ reportData.client.display_name }} {{ $t("custom_report") }}
          </button>
          <button class="dt-button v1" @click.stop="onInvoiceExportClick">
            {{ $t("invoice_export") }}
          </button>
          <button class="dt-button v1" @click.stop="onCostExportClick">
            {{ $t("cost_export") }}
          </button>
          <button
            class="dt-button v1"
            @click.stop="onNewInvoiceExportBookingClick"
          >
            {{ $t("new") }} {{ $t("invoice_export_booking") }}
          </button>
        </div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import * as ActionTypes from "../../store/types";
import { mapKeyToAction } from "../../../../store/global";
import { AccountingStoreNamespace as storeNS } from "../../store";

import DatePicker from "@plugins/text-field/date-picker";
import { addRemoveSet, openWindow, downloadFile } from "../../../../utility";
import { ReportService } from "../../services/report.service";
import { mapGetters } from "vuex";

export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      start_date: "",
      end_date: "",

      selectedInvoiceProjects: new Set(),
      selectAllNone: null,

      bookingDates: [
        { text: "Booking Date", value: "booking_date" },
        { text: "Invoice Date", value: "invoice_date" },
        { text: "Payment Date", value: "payment_date" },
      ],
      selectedBookingDate: { text: "Invoice Date", value: "invoice_date" },
    };
  },
  computed: {
    ...mapGetters(storeNS, {
      reportData: "reportData",
    }),
    date_obj: function () {
      return {
        ...(this.selectedBookingDate.value == "payment_date" && {
          payment_start_date: this.start_date,
          payment_end_date: this.end_date,
        }),
        ...(this.selectedBookingDate.value == "booking_date" && {
          booking_start_date: this.start_date,
          booking_end_date: this.end_date,
        }),
        ...(this.selectedBookingDate.value == "invoice_date" && {
          invoice_start_date: this.start_date,
          invoice_end_date: this.end_date,
        }),
      };
    },
    reportPayload: function () {
      return {
        ...this.date_obj,
        invoice_project_id: Array.from(this.selectedInvoiceProjects),
      };
    },
  },
  methods: {
    onDateChange: function (name, value) {
      console.log(name, value);
      this[name] = value;
      console.log(this[name]);
    },
    onInvoiceProjectSelect: function (event, invoice_project_id) {
      this.selectedInvoiceProjects = addRemoveSet(
        event.target.checked,
        this.selectedInvoiceProjects,
        invoice_project_id
      );
    },
    onBookingDateChange: function (value) {
      console.log(value);
      this.selectedBookingDate = value;
    },
    onInvoiceExportBookingClick: async function () {
      const url = ReportService.exportBooking({
        ...this.reportPayload,
      });
      downloadFile(url);
    },
    onInvoicelineExport: async function () {
      const url = ReportService.exportBooking({
        ...this.reportPayload,
        invoiceline: 1,
      });
      
       downloadFile(url);
    },
    onCustomReportClick: async function () {
      const url = ReportService.exportBooking({
        ...this.reportPayload,
        report_type: "new",
      });
      downloadFile(url);
    },
    onInvoiceExportClick: function () {
      const url = ReportService.exportBooking({
        ...this.reportPayload,
        mini_report: "invoice",
      });
      downloadFile(url);
    },
    onCostExportClick: function () {
      const url = ReportService.exportBooking({
        ...this.reportPayload,
        mini_report: "cost",
      });
      downloadFile(url);
    },
    onNewInvoiceExportBookingClick: function () {
      const url = ReportService.exportBooking({
        ...this.reportPayload,
        mini_report: "invioce_xmltemplate",
      });
      console.log(url);
      downloadFile(url);
    },
    onInvoiceProjectSelectAllNone: function (e) {
      const checked = e.target.checked;
      console.log(checked);
      if (checked) {
        this.selectAllNone = true;
        this.selectedInvoiceProjects = new Set(
          this.reportData.invoice_projects.map((e) => e.invoice_project_id)
        );
        console.log(this.selectedInvoiceProjects);
      } else {
        this.selectAllNone = false;
        this.selectedInvoiceProjects = new Set();
      }
    },
    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-accounting-reports-invoice-reports {
  .dt-list {
    height: calc(100vh - 120px);
    overflow-y: auto;
    .dt-list-item {
      .dt-list-item--column {
        &:nth-child(1) {
          flex: 0.2 !important;
        }
      }
    }
  }
  .report-buttons {
    display: flex;
    flex-direction: column;
    button {
      text-transform: uppercase;
    }
  }

  .dt-dropdown {
    margin: 0px 4px;
  }
}
</style>